export { default as AssistantLocation } from './AssistantLocation';
